import { useEffect, useRef, useState } from 'react'

/**
 * Tells you when an element gets close to the viewport, once.
 * Used to defer mounting the carousels' images until they are almost in view,
 * so they don't compete for bandwidth with the hero and the upsell image.
 */
export function useNearViewport<T extends HTMLElement>(rootMargin = '400px') {
  const ref = useRef<T>(null)
  const [isNear, setIsNear] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node || isNear) return

    if (typeof IntersectionObserver === 'undefined') {
      setIsNear(true)
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setIsNear(true)
          observer.disconnect()
        }
      },
      { rootMargin },
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [isNear, rootMargin])

  return { ref, isNear }
}
